import { validateForm } from "@/shared/scripts/ValidateForm";
import { i18n } from "./helpers/translation/i18n";

import store from "../store/index";

export function validateCustomerForm(callbackFunction: (success: boolean) => void): void {
    const customerForm = document.getElementById("newCustomerForm") as HTMLFormElement;

    if (customerForm) {
        const isFormValid = validateForm(customerForm);
        if (isFormValid.value === true) {

            store.commit("CustomersModule/resetCustomerFormError");

            callbackFunction(true);
        } else {
            store.commit("CustomersModule/setCustomerFormError", isFormValid.errors);

            callbackFunction(false);
        }
    } else {
        const currentCustomer = store.getters["CustomersModule/getCurrentCustomer"];

        if (currentCustomer) {

            store.commit("CustomersModule/resetCustomerFormError");

            callbackFunction(true);
        } else {
            store.commit("CustomersModule/setCustomerFormError", {
                "customers": i18n.t("please_select_a_customer")
            });

            callbackFunction(false);
        }
    }
}
